import { Head, useForm } from '@inertiajs/react'
import { HomeMark } from '../../shared/HomeMark.jsx'
import { withSiteFooter } from '../../shared/SiteFooter.jsx'
import { Button } from '../../components/core/Button.jsx'
import { Field } from '../../components/forms/Field.jsx'
import { Input } from '../../components/forms/Input.jsx'

export default function ResetNew({ token = '', errors = {} }) {
  const form = useForm({ password: '', password_confirmation: '' })

  function submit(e) {
    e.preventDefault()
    form.patch(`/passwords/${token}`)
  }

  return (
    <>
      <Head title="Set a new password" />
      <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-8 px-6 py-16">
        <HomeMark />
        <div className="flex flex-col gap-2">
          <h1 className="page-title">Set a new password</h1>
          <p className="text-[15px] text-[color:var(--text-body)]">
            Setting a new password signs out every device. Any collection that was running will
            continue.
          </p>
        </div>

        <form onSubmit={submit} className="flex flex-col gap-5">
          <Field
            label="New password"
            htmlFor="password"
            required
            hint="At least 8 characters, including a number and a symbol."
            error={errors.password}
          >
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              value={form.data.password}
              invalid={Boolean(errors.password)}
              onChange={(e) => form.setData('password', e.target.value)}
            />
          </Field>

          <Field
            label="Confirm new password"
            htmlFor="password_confirmation"
            required
            error={errors.password_confirmation}
          >
            <Input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              value={form.data.password_confirmation}
              invalid={Boolean(errors.password_confirmation)}
              onChange={(e) => form.setData('password_confirmation', e.target.value)}
            />
          </Field>

          <Button variant="primary" size="lg" block as="button" loading={form.processing}>
            Save the new password
          </Button>
        </form>
      </main>
    </>
  )
}

ResetNew.layout = withSiteFooter
